export const ObjectAllowedCssClasses = ["danger", "success"];
export const ObjectAllowedTitles = [
  "MODULES.GENERAL.NOTALLOWED",
  "MODULES.GENERAL.ALLOWED",
];

export const ObjectFullAccessCssClasses = ["danger", "success"];
export const ObjectFullAccessTitles = [
  "MODULES.GENERAL.SHOWACCESS",
  "MODULES.GENERAL.FULLACCESS",
];

export const ObjectHolidayCssClasses = ["danger", "success"];
export const ObjectHolidayTitles = [
  "MODULES.GENERAL.HOLIDAY",
  "MODULES.GENERAL.WORKDAY",
];

export const ObjectHasClosetCssClasses = ["danger", "success"];
export const ObjectHasClosetTitles = [
  "MODULES.GENERAL.HAS_NOT_CLOSET",
  "MODULES.GENERAL.HAS_CLOSET",
];

export const ObjectClosetFullStatusCssClasses = ["danger", "success"];
export const ObjectClosetFullStatusTitles = [
  "MODULES.SPORT.CLOSET.FULL",
  "MODULES.SPORT.CLOSET.EMPTY",
];

export const ObjectClosetUsableStatusCssClasses = ["danger", "success"];
export const ObjectClosetUsableStatusTitles = [
  "MODULES.SPORT.CLOSET.UNUSABLE",
  "MODULES.SPORT.CLOSET.USABLE",
];

export const defaultSorted = [{ dataField: "id", order: "desc" }];
export const sizePerPageList = [
  { text: "10", value: 10 },
  { text: "20", value: 20 },
  { text: "30", value: 30 },
  { text: "50", value: 50 },
];
